<app-medshorts-about *ngIf="isMedshorts"></app-medshorts-about>
<app-medigi-about *ngIf="isMedigi"></app-medigi-about>
